import { theme } from "src/styles/theme";
import Layout from "src/layout";
import styled from "styled-components";
import { QcastHeader } from "./QcastHeader";
import { QcastSidebar } from "./QcastSidebar";
import { ResponsesPanel } from "./ResponsesPanel";
import QCastContent from "src/pages/Play/QCastContent";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import queryString from 'query-string';

import { useBoundStore } from 'src/store';
import Modal from "src/components/Modal";
import { FiTwitter, FiFacebook, FiLinkedin, FiInstagram } from "react-icons/fi";
import Loader from "src/components/Loader";
import { getTotalVideoDurationSigngle } from "src/shared/utils/helper";
// import useASRWorker from "src/hooks/useASRWorker";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  gap: 0px;

`;


const PlayContainer = styled.div<{expand: boolean}>`
  width: ${({ expand }) => (expand ? '100%' : 'calc(100vw - 480px)')};
  height: calc(100svh - 78px);// auto;
  display: flex;
  flex-direction: column;

  gap: 5px;
  border-top-left-radius: 20px;
  padding: 2px 20px 15px 20px;
  border-right-width: 1px;
  background: #F7F7FA;
  @media(max-width: ${theme.breakpoints.maxDesktop}px) { 
    width: 100%; 
    }
    @media (max-width: ${theme.breakpoints.mobile}px) {
      height: calc(100svh - 45px);
  }
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: start;
  gap: 40px;
  height:100%;
`;


const BackgroundGlow1 = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  top: 20%;
  left: 30%;
  background: ${theme.colors.gradients.purpleGlow};
  opacity: 0.15;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;

const BackgroundGlow2 = styled.div`
  position: absolute;
  width: 600px;
  height: 600px;
  top: 60%;
  right: 10%;
  background: ${theme.colors.gradients.blueGlow};
  opacity: 0.1;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;
const BackgroundGlow3 = styled.div<{imgPath: string}>`
  position: absolute;
  width: 800px;
  height: 800px;
  top: 20%;
  left: 30%;
  background-image: url(${props=>props.imgPath});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.15;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;

const Socials = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 30px;
  justify-content: center;
  align-items: center;
`

const Play = () => {
  const VideoLists: any = [
    {url: "https://qcast.io/static/media/alton_intro.4b99e522.mp4", question: "This is one of the question in this Qcast", comment: 2},
    {url: "https://qcast.io/static/media/alton_q1.b802f90b.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q2.9b5e43a3.mp4", question: "This is one of the question in this Qcast", comment: 5},
    {url: "https://qcast.io/static/media/alton_q3.150f9d43.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q4.b94db439.mp4", question: "This is one of the question in this Qcast", comment: 7},
    {url: "https://qcast.io/static/media/alton_q5.23659789.mp4", question: "This is one of the question in this Qcast", comment: 9},
    {url: "https://qcast.io/static/media/alton_q6.fdeb0ef7.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q7.3366e4fe.mp4", question: "This is one of the question in this Qcast", comment: 7},
    {url: "https://qcast.io/static/media/alton_q8.5df69581.mp4", question: "This is one of the question in this Qcast", comment: 9},
    {url: "https://qcast.io/static/media/alton_q9.b1991e18.mp4", question: "This is one of the question in this Qcast", comment: 9}
  ];

  const [videos, setVideos] = useState<any[]>([]);
  const [isSocialModalOpen, setIsSocialModalOpen] = useState(false);
  const [socialMedia, setSocialMedia] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { globalSettings,transcription, questions, activityLoader, loadQuestions, setQuestionIndex, setExpandSidebar, expandSidebar } = useBoundStore();
  const isNotPC = useMediaQuery({ maxWidth: theme.breakpoints.maxDesktop });
  // const { isModelLoaded, loadModel } = useASRWorker();
  const [hidePannel, setHidePannel] = useState(false);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);


  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const loadModels=async()=>{
    try {
      const pathname = window.location.pathname;
     /*  if(pathname.split('/').length > 1){
        const code = pathname.split('/')[1];
        const qcastId = atob(code);
        await loadQuestions(qcastId);
      } */
      
      if(urlParams.has('userId') && urlParams.has('qcastId')){
        const userId = urlParams.get('userId');
        const qcastId = urlParams.get('qcastId');
        localStorage.setItem("qcastId",qcastId)
        localStorage.setItem("userId",userId)
        await loadQuestions(qcastId, userId);
      }
      

    } catch (error) {
      console.error("Error loading model:", error);
    }finally{
      setIsLoading(false);
    }
  }
  const handleSelectQcast =(index: number)=>{
    setCurrentIndex(index);
  }

  const handleResponse = async()=>{
    await setQuestionIndex(currentIndex);
    navigate("/qcast/respond")
  }

  const handleSocialShare=useCallback((status: boolean)=>{
    setIsSocialModalOpen(status);
  }, []);

  const processQuestions = async() => {

    let response=[]
    let idx=0
    const videoQstn: any = questions && Object.keys(questions).length > 0 && questions?.listOfVideos instanceof Array
    if(videoQstn){
      for(const vid of questions.listOfVideos||[]){
        let durations=await getTotalVideoDurationSigngle(vid)
        response.push(
          {
            url: vid,
            question: questions?.title,
            comment: 0,
            duration:durations,
            maxDuration: questions?.listOfResponsesLimits[idx]
          }
        )
        idx++;
      }
    }
    setVideos(response);
  }

  

  
  useEffect(() => {
    loadModels();
  }, []);


  
  useEffect(()=>{
    if(questions && Object.keys(questions).length > 0){
      processQuestions();
    }
  }, [questions]);

  //  useEffect(()=>{
  //   if(!isModelLoaded){
  //     loadModel();
  //   }
  // }, [])

  console.log(transcription)
  return (
    <Layout>
      {isLoading && <Loader />}
      <Container>
        <PlayContainer expand={expandSidebar && !isNotPC}>
          <QcastHeader 
            qcasterName={questions?.profileName||"Qcast"}
            qseriesName="QSerious Name" 
            avatarSrc= {questions?.coverPhoto} 
            mediaType={socialMedia}
            onShare={handleSocialShare} />
          <PageContent>
            <QCastContent 
              videoLists={videos} 
              selectQcastIndex={currentIndex} 
              onUpdateQcastIndex={handleSelectQcast} 
              onResponse={handleResponse} 
            />  
          </PageContent>
          
        </PlayContainer>
        {!expandSidebar && !isNotPC && (
          <QcastSidebar 
            title={questions?.title||""}
            videos={videos} 
            transcription={transcription} 
            videoIndex={currentIndex}
            answerCount={questions && questions?.qcastResponseList?.length || 0} 
            avatarSrc= {questions?.coverPhoto}
            onSelectQcast={handleSelectQcast}
            onHidePannel={setExpandSidebar}
          />   
        )}
         
      </Container>
      {isSocialModalOpen && (
        <Modal
          isOpen={isSocialModalOpen}
          onClose={() => setIsSocialModalOpen(false)}
        >
          <div>
              <p style={{fontSize: 20, fontWeight: 500, color: theme.colors.black}}>Share this Qcast on social media</p>
              <Socials>
                <button onClick={()=>setSocialMedia("twitter")}><FiTwitter size={50} /></button>
                <button onClick={()=>setSocialMedia("facebook")}><FiFacebook size={50} /></button>
                <button onClick={()=>setSocialMedia("linkedin")}><FiLinkedin size={50} /></button>
                <button onClick={()=>setSocialMedia("instagram")}><FiInstagram size={50} /></button>
              </Socials>
            </div>
        </Modal>
      )}
    </Layout>
  );
};

export default Play;